export default "__VITE_ASSET__DNwbJlHP__"